import * as React from "react";
import { cn } from "@/lib/utils";

const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, ...props }, ref) => (
  // biome-ignore lint/a11y/noLabelWithoutControl: forwarded component relies on consumer to pass control association
  <label
    ref={ref}
    className={cn(
      "text-xs font-bold text-primary/90 mb-1 block",
      className
    )}
    {...props}
  />
));
Label.displayName = "Label";

export { Label };
